import { array, Decoder, field, nullable, number, object } from 'json-bouncer'
import * as PrismaManufacturerStatus from './PrismaManufacturerStatus'
import * as PrismaRequest from './PrismaRequest'
import * as PrismaRequestOfferWithManufacturerStatus from './PrismaRequestOfferWithManufacturerStatus'
import {Product, productDecoder} from './Product'

export interface M {
    readonly prismaRequestOffersWithManufacturerStatus: PrismaRequestOfferWithManufacturerStatus.M[] | null
    readonly prismaRequest: PrismaRequest.M
    readonly prismaRequestManufacturerStatus: PrismaManufacturerStatus.M | null
    readonly printProduct: Product
    readonly customerId: number
}

export function decoder(): Decoder<M> {
    return object({
        prismaRequestOffersWithManufacturerStatus:
            field('prismaRequestOffersWithManufacturerStatus',
                nullable(array(PrismaRequestOfferWithManufacturerStatus.decoder()))),
        prismaRequest: field('prismaRequest', PrismaRequest.decoder()),
        prismaRequestManufacturerStatus:
            field('prismaRequestManufacturerStatus', nullable(PrismaManufacturerStatus.decoder())),
        printProduct: field('printProduct', productDecoder()),
        customerId: field('customerId', number()),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/PrismaRequestWithOffersForList.ts